'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = personal_order_detail;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    order: {},
    payment_in_id: null,
    preload: false
};

function personal_order_detail() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.Personal.OrderDetail.PERSONAL_ORDER_DETAIL_LOAD:
            return (0, _extends3.default)({}, state);
        case _constants.Personal.OrderDetail.PERSONAL_ORDER_DETAIL_SUCCESS:
            return (0, _extends3.default)({}, state, {
                order: action.result
            });
        case _constants.Personal.OrderDetail.PERSONAL_ORDER_DETAIL_FAIL:
            return (0, _extends3.default)({}, state, {
                order: {}
            });
        case _constants.Personal.OrderDetail.SET_PAYMENT_ID:
            {
                return {
                    payment_in_id: action.paymentId
                };
            }
        case _constants.Personal.OrderList.ORDER_SETTING_SEND:
            return (0, _extends3.default)({}, state, {
                preload: true
            });
        case _constants.Personal.OrderList.ORDER_SETTING_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                result: action.result
            });
        case _constants.Personal.OrderList.ORDER_SETTING_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false
            });
        case _constants.Personal.OrderList.ORDER_SET_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false
            });
        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/personal/personal_order_detail.js
// module id = 1909
// module chunks = 0